import type { VipEntitlement } from '@/api/auth'

const SHANGHAI_TIMEZONE = 'Asia/Shanghai'

function shanghaiDateKey(now = new Date()): string {
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: SHANGHAI_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now)
  const value = (type: 'year' | 'month' | 'day') =>
    parts.find((part) => part.type === type)?.value ?? ''
  return `${value('year')}-${value('month')}-${value('day')}`
}

export function vipNoticeDismissKey(
  entitlement: VipEntitlement,
  now = new Date(),
): string {
  return [
    'vip-entitlement-notice',
    entitlement.subscription_id,
    entitlement.notice_type,
    shanghaiDateKey(now),
  ].join(':')
}

export function shouldShowVipNotice(
  entitlement: VipEntitlement | null | undefined,
  storage: Pick<Storage, 'getItem'> = localStorage,
): entitlement is VipEntitlement {
  if (!entitlement || entitlement.notice_type === 'none') return false
  return storage.getItem(vipNoticeDismissKey(entitlement)) !== 'dismissed'
}
